export enum ModalTypeEnum {
  OrderChange = "orderChange",
  StatusUpdate = "statusUpdate",
  QuoteChange = "quoteChange",
  InvoiceChange = "invoiceChange",
  SapOrderReturn = "sapOrderReturn",
}
